<template>
  <div class="col-lg-12">
    <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true">
    </loading>
    <gmap-map
      style="height: 550px;"
      id="map"
      map-type-id="roadmap"
      :zoom="3"
      :center="center"
    >
      <gmap-marker 
      v-for="client in clients" :key="client.cid"
      :position="client.localization"
      :icon="client.icon"
      :clickable="true"
      @click="openInfoWindowTemplate(client)"
      />
      <gmap-info-window
        :options="{maxWidth: 300}"
        :position="infoWindow.position"
        :opened="infoWindow.open"
        @closeclick="infoWindow.open=false">
        <div v-html="infoWindow.template"></div>
      </gmap-info-window>

    </gmap-map>
  </div>
  
</template>
<script>
  import Vue from 'vue'
  import * as VueGoogleMaps from 'vue2-google-maps'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAKsG8IQHDsqs1cNVgIZTOJcClhV6uGQjI'
  }
})

  export default{
    components: {
      Loading
    },
    methods: {
     async getClients() {
        const self = this;
        const response = await fetch(this.$api_url+'/clients', {
          method: 'GET',
          credentials: 'include',
        });
        if(response.ok) { 
          const json = await response.json();
          //check if api return regenerated token
          if(json.code != 409) {
            self.log_api("success",'GET /clients', '', json)
            Object.keys(json).forEach(function (key) {
              json[key]['localization'] = {
                lat:Number(json[key]['lat']),
                lng:Number(json[key]['lng']),
              }
              let actual_timestamp = Math.floor(Date.now() / 1000)
              if(json[key].datelastcmd == 0) {
                json[key]['icon'] = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
              } else if(actual_timestamp - json[key].datelastcmd > 15778800) {
                json[key]['icon'] = "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
              } else if(actual_timestamp - json[key].datelastcmd > 7889400) {
                json[key]['icon'] = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
              } else {
                json[key]['icon'] = "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
              }
              self.clients.push(json[key])
            })
            this.isLoading = false
            return json
          }
        }
        this.isLoading = false
      },
      openInfoWindowTemplate (item) {
        this.infoWindow.template = item.company+'<br>'+item.address+'<br>'+item.zipcode+' '+item.city
        this.infoWindow.position = {lat: Number(item.lat), lng: Number(item.lng)}
        this.infoWindow.open = true
      }
    },
    computed: {
    
    },
    data () {
      return {
        center: {
          lat:48.8589507,
          lng:2.2770204
        },
        clients: [],
        infoWindow: {
          position: {lat: 0, lng: 0},
          open: false,
          template: ''
        },
        isLoading: true,
      }
    },
    mounted() {
      this.getClients();
    },
  }
</script>